export const CORE_STORE = 'wp-mail-debugger/core';
export const ADMIN_PAGE_STORE = 'wp-mail-debugger/admin-page';
export const SETTING_PREFIX = 'wp_mail_debugger_';
